import EventIcon from '@mui/icons-material/Event';
import { Box, InputAdornment, Grid, Typography } from "@mui/material";
import DateEditor from "../../common/EditorContainer/DateEditor";
import DurationPopper from "../../common/EditorContainer/DurationEditor/DurationPopper";
import CurrentUserCellValue from "../common/CurrentUserCellValue";
import UserField from "./UserField";

const bps = {
  left: { xs: 6, sm: 2, md: 2 },
  right: { xs: 6, sm: 4, md: 2 },
};

const typography = {
  body: { fontSize: "13px", lineHeight: "18px", textTransform: "none", paddingLeft: "2px", paddingRight: "2px" },
  h6: { fontSize: "17px", fontWeight: 500, paddingLeft: "2px", paddingRight: "2px", paddingBottom: "4px" },
  label: { fontSize: "13px" },
};

const textInputProps = {
  disableUnderline: true,
  startAdornment: //Set to null if not show.
    //null,
    <InputAdornment position="start">
      <Box sx={{ display: 'flex', alignItems: 'center', width: "16px", paddingLeft: "4px" }}>
        <EventIcon sx={{
          opacity: 0.7, fontSize: '16px',
        }} />
      </Box>
    </InputAdornment>,
  endAdornment: //Set to null if not show.
    null,
  sx: {
    '&.MuiInputBase-root': {
      padding: 0,
    },
    '&.MuiInputBase-root.MuiInput-root': {
      padding: 0,
      "&.Mui-error": {
        color: /* theme.palette.error.dark */ "red",
      },
    },
    width: "100%",
    backgroundColor: '#ffffff',
    textAlign: 'left',
    cursor: "text",
    padding: '4px',
    fontSize: '13px',
    minHeight: '1.5em',
    color: 'rgba(0, 0, 0, 0.87)',
    border: '1px solid rgba(0, 0, 0, 0)',
    borderRadius: "4px",
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
    '&.Mui-focused': {
      border: '1px solid rgba(0, 0, 0, 0.5)',
    },
  },
};

const TaskDetailsGrid = ({
  columns,
  disabled,
  editItem,
  enableEdit,
  handleAddTimeLog,
  handleDeleteTimeLog,
  handleTaskAssignmentPropertyChange,
  handleTaskDatePropertyChange,
  handleTaskPropertyChange,
  handleTaskPropertyValidationChange,
  handleTaskValueChange,
  handleUpdateTimeLog,
  item,
  userLookup,
}) => {
  return (
    <Grid container columnSpacing={2} rowSpacing={1}>

      <Grid item {...bps.left}>
        <Typography variant="body1" sx={typography.label}>Startdatum</Typography>
      </Grid>
      <Grid item {...bps.right}>
        <DateEditor disabled={disabled} enableEdit={enableEdit} value={item.startDate} views={['year', 'month', 'day']}
          onChange={(value) => handleTaskDatePropertyChange("startDate", value)} textInputProps={textInputProps}
          onValidationChange={(valid) => handleTaskPropertyValidationChange?.("startDate", valid)}
        />
      </Grid>

      <Grid item {...bps.left}><Typography variant="body1" sx={typography.label}>Förfallodatum</Typography></Grid>
      <Grid item {...bps.right}>
        <DateEditor disabled={disabled} enableEdit={enableEdit} value={item.endDate} views={['year', 'month', 'day']}
          onChange={(value) => handleTaskDatePropertyChange("endDate", value)} textInputProps={textInputProps}
          onValidationChange={(valid) => handleTaskPropertyValidationChange?.("endDate", valid)}
        />
      </Grid>

      <Grid item {...bps.left}><Typography variant="body1" sx={typography.label}>Tilldelad</Typography></Grid>
      <Grid item {...bps.right}><UserField
        disabled={disabled}
        editable={enableEdit}
        name="assignments"
        onChange={({ name, value }) => handleTaskAssignmentPropertyChange(name, value)}
        userLookup={userLookup}
        value={editItem.assignments ? editItem.assignments[0] : null}
      /></Grid>

      <Grid item {...bps.left}><Typography variant="body1" sx={typography.label}>Rapporterad tid</Typography></Grid>
      <Grid item {...bps.right}><DurationPopper
        disabled={disabled}
        enableEdit={enableEdit}
        item={item}
        onAdd={handleAddTimeLog}
        onDelete={handleDeleteTimeLog}
        onUpdate={handleUpdateTimeLog}
        startIcn={true}
        sx={{
          color: "rgba(0, 0, 0, 0.87)",
          border: "1px solid rgba(0, 0, 0, 0)",
          borderRadius: "4px",
          fontSize: "13px",
          fontWeight: 400,
          minHeight: "1.5em",
          lineHeight: "22px",
          padding: "4px",
          width: "100%",
          "&.MuiBox-root": { minHeight: "1.5em", padding: "0px 0px 0px 4px", border: "0px", },
          "& .MuiTypography-root": { whiteSpace: "pre-wrap", padding: "0px", },
          "&.MuiInputBase-root": { border: "1px solid rgba(0, 0, 0, 0.5)", },
          "&:hover": { backgroundColor: '#f0f0f0', cursor: "text", },
        }}
      /></Grid>

      {columns?.map((column, index) => (
        <>
          <Grid item {...bps.left}>
            <Typography variant="body1" sx={typography.label}>{column.label}</Typography>
          </Grid>
          <Grid item {...bps.right}>
            {column.renderCell(editItem, handleTaskValueChange, enableEdit, false, disabled, handleTaskPropertyValidationChange)}
          </Grid>
        </>
      ))}

      <Grid item {...bps.left}><Typography variant="body1" sx={typography.label}>Ägare</Typography></Grid>
      <Grid item  {...bps.right}>
        {editItem.createdBy && (
          <UserField
            disabled
            name="createdBy"
            onChange={({ name, value }) => handleTaskPropertyChange(name, value)}
            userLookup={userLookup}
            value={editItem.createdBy}
          />
        )}
        {!editItem.createdBy && (
          <CurrentUserCellValue />
        )}
      </Grid>

    </Grid>
  )
}

export default TaskDetailsGrid;
